import Image from "next/image";
import BasicBlock from "../shared/basic-block";
import CTAButton from "./CTAButton";

const testimonials = [
  {
    name: "Musa",
    avatar: "https://cdn-crayo.com/lp/public/landing/testimonials/musa.png",
    text: "I've clipped for some of the biggest creators on the internet. Crayo is the tool I wish I had when I started.",
  },
  {
    name: "Jonathan",
    avatar: "https://cdn-crayo.com/lp/public/landing/testimonials/olivia.png",
    text: "Crayo is the only tool I've found that can remove backgrounds from videos well. 10/10.",
  },
  {
    name: "Daniel",
    avatar: "https://cdn-crayo.com/lp/public/landing/testimonials/daniel.png",
    text: "After running channels with over 1 million subscribers, I built Crayo to solve my own scaling problems.",
  },
  {
    name: "Dave",
    avatar: "https://cdn-crayo.com/lp/public/landing/testimonials/jake.png",
    text: "Crayo makes formatting and clipping content so much easier, now I can focus on finding the clips & trends.",
  },
  {
    name: "Brandon",
    avatar: "https://cdn-crayo.com/lp/public/landing/testimonials/chloe.png",
    text: "Their image generator is insane. It saves me from needing multiple subscriptions for different AI models.",
  },
  {
    name: "James",
    avatar: "https://cdn-crayo.com/lp/public/landing/testimonials/noah.png",
    text: "I wish I found this sooner. Reddit story generations are OP for YouTube Shorts. Most worth it subscription I have.",
  },
];

const TestimonialsHeader = (
  <>
    <h3 className="hidden text-center text-[32px] font-semibold leading-[1.1] md:block md:text-[48px]">
      Crayo Has Generated Billions of Views.
      <br />
      For Millions of Clippers.
    </h3>
    <h3 className="block text-center text-[32px] font-semibold leading-[1.1] md:hidden md:text-[48px]">
      See What Our Users Are Saying
    </h3>
  </>
);

const Testimonials = () => (
  <BasicBlock
    header={TestimonialsHeader}
    contentStyle="items-center justify-center flex-col md:gap-[100px] gap-[50px]"
  >
    <div className="grid w-full grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
      {testimonials.map((testimonial) => (
        <div
          key={testimonial.name}
          className="flex flex-col gap-4 rounded-xl border border-[#EFF2FF] p-6 shadow-sm"
        >
          <div className="flex items-center justify-between gap-2">
            <div className="flex select-none items-center gap-3">
              <Image
                src={testimonial.avatar}
                alt={testimonial.name}
                width={40}
                height={40}
                draggable={false}
              />
              <p className="text-sm font-semibold text-black">{testimonial.name}</p>
            </div>
          </div>
          <p className="text-base text-[#383838]">{testimonial.text}</p>
        </div>
      ))}
    </div>
    <CTAButton
      cta={{ text: "Make an account", href: "https://crayo.ai/signup" }}
      className="rounded-[20px] px-7 py-5 text-2xl"
    />
  </BasicBlock>
);

export default Testimonials;
